import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Localizacion } from 'lib.front';

const options = {
    filterType: 'dropdown',
    selectableRows: 'none',
    responsive: 'standard',
    pagination: true,
    searchOpen: true,
    search: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    rowHover: false,
    print: false,
    download: false,
    viewColumns: true,
    filter: true,
    textLabels: Localizacion.muiDataTables.ES
};

export const Tabla = ({ columns, data }) => {
    return (
            <MUIDataTable columns={columns} data={data} options={options} />
    );
};
